import http from "./httpService";

const endPoint = "/api/v1/Products";


export async function addProduct(request) {
    return await http.post(endPoint, request);
}

export async function getAllProducts(customer, organization, category) {
    return await http.get(`${endPoint}/All`, {
        headers: {
            'customerId': customer,
            'organizationId': organization
        },
        params: {
            categoryId: category
        }
    });
}

export function updateProduct(request) {
    return http.put(`${endPoint}`, request );
}

export function updateProductImage(id, request) {
    return http.put(`${endPoint}/${id}/Image`, request );
}


export default { addProduct, getAllProducts, updateProduct, updateProductImage };


// WEBPACK FOOTER //
// ./src/services/ProductsService.js